var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _ellipse, _ellipse2, _ellipse3, _ellipse4, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _ellipse5, _ellipse6, _ellipse7, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _path140, _path141, _path142, _path143, _path144, _path145, _path146, _path147, _path148, _path149, _path150, _path151, _path152, _path153, _path154, _path155, _path156, _path157, _path158, _path159, _path160, _path161, _path162, _path163, _path164, _path165, _path166, _path167, _path168, _path169, _path170, _path171, _path172, _path173, _path174, _path175, _path176, _path177, _path178, _path179, _path180, _path181, _path182, _path183, _path184, _path185, _path186, _path187, _path188, _path189, _path190, _path191, _path192, _path193, _path194, _path195, _path196, _path197, _path198, _path199, _path200, _g, _path201, _g2, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTasShort(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 185,
    height: 226,
    viewBox: "0 0 185 226",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_10512_2063)"
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 185,
    height: 226,
    rx: 24,
    fill: "#601F93"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.4
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M67.2227 199.982C19.3922 202.408 19.7315 233.806 16 251.625V268.542L231.746 277L235.477 154.861C242.601 117.644 174.982 97.4061 149.315 121.365C122.855 146.064 127.265 196.937 67.2227 199.982Z",
    fill: "#6A48B3"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M125.706 209.383H115.611V220.946H125.706V209.383Z",
    fill: "#463332"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M125.706 211.812H115.611V215.434H125.706V211.812Z",
    fill: "#463332"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M155.859 155.094H85.4579C83.3523 155.094 81.6454 156.79 81.6454 158.883V207.926C81.6454 210.018 83.3523 211.715 85.4579 211.715H155.859C157.965 211.715 159.672 210.018 159.672 207.926V158.883C159.672 156.79 157.965 155.094 155.859 155.094Z",
    fill: "url(#paint0_linear_10512_2063)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M81.6454 204.869V208.076C81.6454 210.266 83.3517 212.051 85.4578 212.051H155.859C157.965 212.051 159.672 210.275 159.672 208.076V204.869H81.6454Z",
    fill: "url(#paint1_linear_10512_2063)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M154.428 156.252H86.8975C84.8803 156.252 83.245 157.877 83.245 159.882V199.12C83.245 201.125 84.8803 202.75 86.8975 202.75H154.428C156.446 202.75 158.081 201.125 158.081 199.12V159.882C158.081 157.877 156.446 156.252 154.428 156.252Z",
    fill: "url(#paint2_linear_10512_2063)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.2
  }, _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M155.015 158.343C154.375 157.672 153.469 157.248 152.464 157.248H87.7417C85.8044 157.248 84.2403 158.803 84.2403 160.728V198.34C84.2403 199.135 84.5069 199.877 84.969 200.46L155.015 158.343Z",
    fill: "white"
  }))), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M108.626 219.285H132.691C133.687 219.285 134.495 220.089 134.495 221.078V223.605H106.813V221.078C106.813 220.089 107.622 219.285 108.617 219.285H108.626Z",
    fill: "url(#paint3_linear_10512_2063)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3
  }, _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M132.691 219.285H120.756C121.752 219.285 122.56 220.089 122.56 221.078V223.605H134.495V221.078C134.495 220.089 133.687 219.285 132.691 219.285Z",
    fill: "#463332"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.3
  }, _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M115.673 220.469C115.673 221.061 112.403 221.185 110.065 221.185C107.995 221.185 107.666 220.867 107.666 220.469C107.666 220.072 108.137 219.754 110.065 219.754C112.403 219.754 115.673 219.886 115.673 220.469Z",
    fill: "white"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M118.179 220.469C118.179 220.707 117.717 220.875 117.211 220.875C116.704 220.875 116.349 220.69 116.349 220.469C116.349 220.248 116.704 220.062 117.211 220.062C117.717 220.062 118.179 220.23 118.179 220.469Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3
  }, _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M134.504 222.811H106.822V223.606H134.504V222.811Z",
    fill: "#463332"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3
  }, _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M159.672 204.869H81.6454V205.903H159.672V204.869Z",
    fill: "#463332"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3
  }, _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M155.157 208.624C155.157 209.436 154.491 210.099 153.673 210.099C152.855 210.099 152.189 209.436 152.189 208.624C152.189 207.811 152.855 207.148 153.673 207.148C154.491 207.148 155.157 207.811 155.157 208.624Z",
    fill: "#463332"
  }))), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M154.66 208.624C154.66 209.163 154.224 209.596 153.682 209.596C153.14 209.596 152.704 209.163 152.704 208.624C152.704 208.085 153.14 207.652 153.682 207.652C154.224 207.652 154.66 208.085 154.66 208.624Z",
    fill: "url(#paint4_linear_10512_2063)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.4
  }, _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M154.761 159.77H123.844V200.888H154.761V159.77Z",
    fill: "#6D4791"
  }))), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M154.761 158.188H123.844V199.306H154.761V158.188Z",
    fill: "#FFF4EE"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M152.69 160.008H125.896V163.974H152.69V160.008Z",
    fill: "url(#paint5_linear_10512_2063)"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M131.351 163.265V160.898H131.636V163.039H132.743V163.265H131.351Z",
    fill: "white"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M133.135 163.265V160.898H134.606V161.131H133.421V161.956H134.504V162.186H133.421V163.032H134.606V163.265H133.135Z",
    fill: "white"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M135.81 163.306C135.635 163.306 135.484 163.274 135.355 163.211C135.225 163.148 135.126 163.06 135.056 162.947C134.985 162.835 134.95 162.704 134.95 162.555H135.249C135.249 162.647 135.271 162.733 135.314 162.812C135.357 162.889 135.419 162.951 135.501 162.998C135.584 163.043 135.687 163.066 135.81 163.066C135.97 163.066 136.095 163.027 136.183 162.951C136.271 162.874 136.316 162.778 136.316 162.663C136.316 162.569 136.295 162.493 136.255 162.437C136.214 162.378 136.158 162.331 136.088 162.295C136.02 162.259 135.941 162.227 135.85 162.2C135.762 162.173 135.669 162.142 135.572 162.109C135.388 162.045 135.253 161.968 135.164 161.875C135.076 161.781 135.032 161.658 135.032 161.507C135.03 161.38 135.059 161.269 135.12 161.172C135.181 161.073 135.267 160.996 135.378 160.942C135.492 160.886 135.625 160.857 135.779 160.857C135.931 160.857 136.062 160.886 136.173 160.942C136.286 160.998 136.373 161.076 136.434 161.175C136.498 161.274 136.531 161.387 136.533 161.513H136.234C136.234 161.448 136.217 161.384 136.183 161.321C136.149 161.255 136.097 161.202 136.027 161.162C135.959 161.121 135.873 161.101 135.769 161.101C135.64 161.099 135.533 161.131 135.45 161.199C135.368 161.267 135.327 161.36 135.327 161.48C135.327 161.581 135.356 161.659 135.412 161.713C135.471 161.767 135.553 161.812 135.657 161.848C135.761 161.882 135.881 161.921 136.017 161.967C136.13 162.007 136.232 162.055 136.322 162.109C136.413 162.163 136.483 162.233 136.533 162.318C136.585 162.404 136.611 162.513 136.611 162.646C136.611 162.759 136.582 162.866 136.523 162.968C136.464 163.067 136.374 163.148 136.255 163.211C136.137 163.274 135.988 163.306 135.81 163.306Z",
    fill: "white"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M137.773 163.306C137.599 163.306 137.447 163.274 137.318 163.211C137.189 163.148 137.089 163.06 137.019 162.947C136.949 162.835 136.914 162.704 136.914 162.555H137.213C137.213 162.647 137.234 162.733 137.277 162.812C137.32 162.889 137.382 162.951 137.464 162.998C137.548 163.043 137.651 163.066 137.773 163.066C137.934 163.066 138.058 163.027 138.147 162.951C138.235 162.874 138.279 162.778 138.279 162.663C138.279 162.569 138.259 162.493 138.218 162.437C138.177 162.378 138.122 162.331 138.051 162.295C137.984 162.259 137.904 162.227 137.814 162.2C137.725 162.173 137.633 162.142 137.535 162.109C137.352 162.045 137.216 161.968 137.128 161.875C137.039 161.781 136.995 161.658 136.995 161.507C136.993 161.38 137.022 161.269 137.084 161.172C137.145 161.073 137.231 160.996 137.342 160.942C137.455 160.886 137.588 160.857 137.742 160.857C137.894 160.857 138.025 160.886 138.136 160.942C138.25 160.998 138.337 161.076 138.398 161.175C138.461 161.274 138.494 161.387 138.496 161.513H138.198C138.198 161.448 138.181 161.384 138.147 161.321C138.113 161.255 138.061 161.202 137.99 161.162C137.922 161.121 137.836 161.101 137.732 161.101C137.603 161.099 137.497 161.131 137.413 161.199C137.331 161.267 137.291 161.36 137.291 161.48C137.291 161.581 137.319 161.659 137.376 161.713C137.435 161.767 137.516 161.812 137.62 161.848C137.724 161.882 137.844 161.921 137.98 161.967C138.093 162.007 138.195 162.055 138.286 162.109C138.376 162.163 138.447 162.233 138.496 162.318C138.548 162.404 138.574 162.513 138.574 162.646C138.574 162.759 138.545 162.866 138.486 162.968C138.427 163.067 138.338 163.148 138.218 163.211C138.1 163.274 137.952 163.306 137.773 163.306Z",
    fill: "white"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M140.059 163.306C139.826 163.306 139.621 163.255 139.444 163.154C139.27 163.05 139.133 162.906 139.033 162.721C138.936 162.536 138.887 162.323 138.887 162.082C138.887 161.84 138.936 161.628 139.033 161.446C139.133 161.261 139.27 161.117 139.444 161.013C139.621 160.909 139.826 160.857 140.059 160.857C140.294 160.857 140.499 160.909 140.674 161.013C140.85 161.117 140.987 161.261 141.085 161.446C141.182 161.628 141.231 161.84 141.231 162.082C141.231 162.323 141.182 162.536 141.085 162.721C140.987 162.906 140.85 163.05 140.674 163.154C140.499 163.255 140.294 163.306 140.059 163.306ZM140.059 163.055C140.233 163.055 140.386 163.017 140.517 162.94C140.651 162.862 140.754 162.75 140.827 162.606C140.901 162.459 140.939 162.284 140.939 162.082C140.939 161.879 140.901 161.705 140.827 161.561C140.754 161.417 140.651 161.306 140.517 161.229C140.386 161.15 140.233 161.111 140.059 161.111C139.885 161.111 139.731 161.15 139.597 161.229C139.466 161.306 139.363 161.417 139.288 161.561C139.216 161.705 139.179 161.879 139.179 162.082C139.179 162.284 139.216 162.459 139.288 162.606C139.363 162.75 139.466 162.862 139.597 162.94C139.731 163.017 139.885 163.055 140.059 163.055Z",
    fill: "white"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M141.642 163.265V160.898H141.927L143.194 162.795V160.898H143.479V163.265H143.194L141.927 161.368V163.265H141.642Z",
    fill: "white"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M145.117 163.265V161.216L144.733 161.3V161.104L145.212 160.898H145.405V163.265H145.117Z",
    fill: "white"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M145.87 163.265V163.066C146.031 162.939 146.182 162.812 146.325 162.683C146.47 162.553 146.598 162.424 146.709 162.298C146.822 162.172 146.91 162.048 146.974 161.926C147.039 161.804 147.072 161.687 147.072 161.574C147.072 161.491 147.057 161.413 147.028 161.341C147.001 161.269 146.955 161.211 146.892 161.169C146.829 161.123 146.743 161.101 146.634 161.101C146.53 161.101 146.443 161.125 146.372 161.172C146.302 161.217 146.249 161.278 146.213 161.355C146.179 161.431 146.162 161.513 146.162 161.601H145.887C145.887 161.446 145.92 161.313 145.985 161.202C146.051 161.09 146.14 161.004 146.254 160.945C146.367 160.887 146.495 160.857 146.637 160.857C146.848 160.857 147.02 160.917 147.154 161.037C147.289 161.154 147.357 161.33 147.357 161.564C147.357 161.704 147.322 161.843 147.252 161.98C147.182 162.115 147.092 162.247 146.984 162.376C146.875 162.502 146.759 162.62 146.634 162.731C146.512 162.841 146.397 162.94 146.291 163.028H147.439V163.265H145.87Z",
    fill: "white"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M137.651 166.801L137.644 166.197H131.351L131.358 166.801H137.651Z",
    fill: "#DDC8BA"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M152.266 166.801L152.252 166.197H138.383L138.397 166.801H152.266Z",
    fill: "#DDC8BA"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M137.651 169.636L137.644 169.033H131.351L131.358 169.636H137.651Z",
    fill: "#DDC8BA"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M152.266 169.636L152.252 169.033H138.383L138.397 169.636H152.266Z",
    fill: "#DDC8BA"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M152.266 168.217V167.613H145.045L145.059 168.217H152.266Z",
    fill: "#DDC8BA"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M144.424 168.217V167.613H131.351L131.365 168.217H144.424Z",
    fill: "#DDC8BA"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M134.951 171.064L134.944 170.461H131.351L131.358 171.064H134.951Z",
    fill: "#DDC8BA"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M144.104 171.037L144.09 170.434H135.69L135.697 171.037H144.104Z",
    fill: "#DDC8BA"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M137.651 173.742L137.644 173.139H131.351L131.358 173.742H137.651Z",
    fill: "#DDC8BA"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M152.266 173.742L152.252 173.139H138.383L138.397 173.742H152.266Z",
    fill: "#DDC8BA"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M137.651 176.578L137.644 175.975H131.351L131.358 176.578H137.651Z",
    fill: "#DDC8BA"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M152.266 176.578L152.252 175.975H138.383L138.397 176.578H152.266Z",
    fill: "#DDC8BA"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M152.266 175.156V174.553H145.045L145.059 175.156H152.266Z",
    fill: "#DDC8BA"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M144.424 175.156V174.553H131.351L131.365 175.156H144.424Z",
    fill: "#DDC8BA"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M134.951 178.006L134.944 177.402H131.351L131.358 178.006H134.951Z",
    fill: "#DDC8BA"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M144.104 177.978L144.09 177.375H135.69L135.697 177.978H144.104Z",
    fill: "#DDC8BA"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M137.651 180.683L137.644 180.08H131.351L131.358 180.683H137.651Z",
    fill: "#DDC8BA"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M152.266 180.683L152.252 180.08H138.383L138.397 180.683H152.266Z",
    fill: "#DDC8BA"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M137.651 183.519L137.644 182.916H131.351L131.358 183.519H137.651Z",
    fill: "#DDC8BA"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M152.266 183.519L152.252 182.916H138.383L138.397 183.519H152.266Z",
    fill: "#DDC8BA"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M152.266 182.097V181.494H145.045L145.059 182.097H152.266Z",
    fill: "#DDC8BA"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M144.424 182.097V181.494H131.351L131.365 182.097H144.424Z",
    fill: "#DDC8BA"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M134.951 184.947L134.944 184.344H131.351L131.358 184.947H134.951Z",
    fill: "#DDC8BA"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M144.104 184.92L144.09 184.316H135.69L135.697 184.92H144.104Z",
    fill: "#DDC8BA"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M137.651 187.625L137.644 187.021H131.351L131.358 187.625H137.651Z",
    fill: "#DDC8BA"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M152.266 187.625L152.252 187.021H138.383L138.397 187.625H152.266Z",
    fill: "#DDC8BA"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M137.651 190.461L137.644 189.857H131.351L131.358 190.461H137.651Z",
    fill: "#DDC8BA"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M152.266 190.461L152.252 189.857H138.383L138.397 190.461H152.266Z",
    fill: "#DDC8BA"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M152.266 189.039V188.436H145.045L145.059 189.039H152.266Z",
    fill: "#DDC8BA"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M144.424 189.039V188.436H131.351L131.365 189.039H144.424Z",
    fill: "#DDC8BA"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M134.951 191.888L134.944 191.285H131.351L131.358 191.888H134.951Z",
    fill: "#DDC8BA"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M144.104 191.861L144.09 191.258H135.69L135.697 191.861H144.104Z",
    fill: "#DDC8BA"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M137.651 193.5L137.644 192.896H131.351L131.358 193.5H137.651Z",
    fill: "#DDC8BA"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M152.266 193.5L152.252 192.896H138.383L138.397 193.5H152.266Z",
    fill: "#DDC8BA"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M137.651 196.336L137.644 195.732H131.351L131.358 196.336H137.651Z",
    fill: "#DDC8BA"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M152.266 196.336L152.252 195.732H138.383L138.397 196.336H152.266Z",
    fill: "#DDC8BA"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M152.266 194.916V194.312H145.045L145.059 194.916H152.266Z",
    fill: "#DDC8BA"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M144.424 194.916V194.312H131.351L131.365 194.916H144.424Z",
    fill: "#DDC8BA"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 128.134,
    cy: 167.799,
    rx: 1.60878,
    ry: 1.60191,
    fill: "url(#paint6_linear_10512_2063)"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 128.134,
    cy: 174.741,
    rx: 1.60878,
    ry: 1.60191,
    fill: "url(#paint7_linear_10512_2063)"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 128.134,
    cy: 181.682,
    rx: 1.60878,
    ry: 1.60191,
    fill: "url(#paint8_linear_10512_2063)"
  })), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 128.134,
    cy: 188.623,
    rx: 1.60878,
    ry: 1.60191,
    fill: "url(#paint9_linear_10512_2063)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.4
  }, _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M119.904 159.979H88.9865V201.097H119.904V159.979Z",
    fill: "#6D4791"
  }))), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M119.904 158.398H88.9866V199.517H119.904V158.398Z",
    fill: "#FFF4EE"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M102.793 166.802L102.786 166.199H96.494L96.501 166.802H102.793Z",
    fill: "#DDC8BA"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M117.408 166.802L117.394 166.199H103.526L103.54 166.802H117.408Z",
    fill: "#DDC8BA"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M102.793 169.638L102.786 169.035H96.494L96.501 169.638H102.793Z",
    fill: "#DDC8BA"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M117.408 169.638L117.394 169.035H103.526L103.54 169.638H117.408Z",
    fill: "#DDC8BA"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M117.408 168.217V167.613H110.188L110.202 168.217H117.408Z",
    fill: "#DDC8BA"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M109.567 168.217V167.613H96.494L96.508 168.217H109.567Z",
    fill: "#DDC8BA"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M100.094 171.068L100.087 170.465H96.494L96.501 171.068H100.094Z",
    fill: "#DDC8BA"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M109.246 171.039L109.232 170.436H100.833L100.84 171.039H109.246Z",
    fill: "#DDC8BA"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M102.793 173.744L102.786 173.141H96.494L96.501 173.744H102.793Z",
    fill: "#DDC8BA"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M117.408 173.744L117.394 173.141H103.526L103.54 173.744H117.408Z",
    fill: "#DDC8BA"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M102.793 176.58L102.786 175.977H96.494L96.501 176.58H102.793Z",
    fill: "#DDC8BA"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M117.408 176.58L117.394 175.977H103.526L103.54 176.58H117.408Z",
    fill: "#DDC8BA"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M117.408 175.158V174.555H110.188L110.202 175.158H117.408Z",
    fill: "#DDC8BA"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M109.567 175.158V174.555H96.494L96.508 175.158H109.567Z",
    fill: "#DDC8BA"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M100.094 178.008L100.087 177.404H96.494L96.501 178.008H100.094Z",
    fill: "#DDC8BA"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M109.246 177.98L109.232 177.377H100.833L100.84 177.98H109.246Z",
    fill: "#DDC8BA"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M102.793 180.685L102.786 180.082H96.494L96.501 180.685H102.793Z",
    fill: "#DDC8BA"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M117.408 180.685L117.394 180.082H103.526L103.54 180.685H117.408Z",
    fill: "#DDC8BA"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M102.793 183.521L102.786 182.918H96.494L96.501 183.521H102.793Z",
    fill: "#DDC8BA"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M117.408 183.521L117.394 182.918H103.526L103.54 183.521H117.408Z",
    fill: "#DDC8BA"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M117.408 182.099V181.496H110.188L110.202 182.099H117.408Z",
    fill: "#DDC8BA"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M109.567 182.099V181.496H96.494L96.508 182.099H109.567Z",
    fill: "#DDC8BA"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M100.094 184.951L100.087 184.348H96.494L96.501 184.951H100.094Z",
    fill: "#DDC8BA"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M109.246 184.922L109.232 184.318H100.833L100.84 184.922H109.246Z",
    fill: "#DDC8BA"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M99.1562 188.909L99.1473 188.141H91.1314L91.1403 188.909H99.1562Z",
    fill: "#DDC8BA"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M117.774 188.909L117.756 188.141H100.089L100.107 188.909H117.774Z",
    fill: "#DDC8BA"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M117.774 187.257V186.488H108.576L108.594 187.257H117.774Z",
    fill: "#DDC8BA"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M107.785 187.257V186.488H91.1314L91.1492 187.257H107.785Z",
    fill: "#DDC8BA"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M95.717 190.577L95.7081 189.809H91.1314L91.1403 190.577H95.717Z",
    fill: "#DDC8BA"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M107.376 190.542L107.359 189.773H96.659L96.6679 190.542H107.376Z",
    fill: "#DDC8BA"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M117.833 160.219H91.0393V164.185H117.833V160.219Z",
    fill: "url(#paint10_linear_10512_2063)"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M96.494 163.485V160.904H96.7984V163.238H97.9796V163.485H96.494Z",
    fill: "white"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M98.3977 163.485V160.904H99.9665V161.158H98.702V162.058H99.8578V162.309H98.702V163.231H99.9665V163.485H98.3977Z",
    fill: "white"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M101.251 163.529C101.065 163.529 100.903 163.495 100.765 163.426C100.628 163.357 100.521 163.261 100.446 163.138C100.372 163.015 100.334 162.873 100.334 162.711H100.653C100.653 162.811 100.676 162.905 100.722 162.991C100.768 163.074 100.834 163.142 100.921 163.194C101.01 163.243 101.12 163.267 101.251 163.267C101.422 163.267 101.555 163.226 101.649 163.142C101.744 163.058 101.791 162.954 101.791 162.829C101.791 162.725 101.769 162.643 101.725 162.581C101.682 162.518 101.623 162.466 101.548 162.427C101.475 162.387 101.391 162.353 101.294 162.323C101.2 162.294 101.101 162.261 100.997 162.224C100.802 162.155 100.657 162.07 100.562 161.969C100.468 161.866 100.421 161.732 100.421 161.567C100.419 161.43 100.45 161.308 100.515 161.202C100.581 161.094 100.672 161.011 100.791 160.952C100.911 160.89 101.054 160.859 101.218 160.859C101.38 160.859 101.52 160.89 101.639 160.952C101.759 161.013 101.852 161.098 101.918 161.206C101.985 161.314 102.02 161.437 102.023 161.575H101.704C101.704 161.503 101.686 161.433 101.649 161.365C101.613 161.293 101.558 161.236 101.483 161.191C101.41 161.147 101.318 161.125 101.207 161.125C101.07 161.122 100.956 161.158 100.867 161.232C100.78 161.306 100.736 161.408 100.736 161.538C100.736 161.649 100.767 161.733 100.827 161.792C100.89 161.851 100.977 161.901 101.088 161.94C101.199 161.977 101.327 162.02 101.472 162.069C101.593 162.113 101.701 162.165 101.798 162.224C101.895 162.283 101.969 162.359 102.023 162.452C102.078 162.546 102.106 162.665 102.106 162.81C102.106 162.933 102.075 163.05 102.012 163.16C101.949 163.269 101.853 163.357 101.725 163.426C101.6 163.495 101.442 163.529 101.251 163.529Z",
    fill: "white"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M103.346 163.529C103.16 163.529 102.998 163.495 102.86 163.426C102.722 163.357 102.616 163.261 102.541 163.138C102.466 163.015 102.429 162.873 102.429 162.711H102.748C102.748 162.811 102.771 162.905 102.817 162.991C102.862 163.074 102.929 163.142 103.016 163.194C103.105 163.243 103.215 163.267 103.346 163.267C103.517 163.267 103.65 163.226 103.744 163.142C103.838 163.058 103.885 162.954 103.885 162.829C103.885 162.725 103.864 162.643 103.82 162.581C103.777 162.518 103.718 162.466 103.643 162.427C103.57 162.387 103.486 162.353 103.389 162.323C103.295 162.294 103.196 162.261 103.092 162.224C102.896 162.155 102.751 162.07 102.657 161.969C102.563 161.866 102.516 161.732 102.516 161.567C102.513 161.43 102.545 161.308 102.61 161.202C102.675 161.094 102.767 161.011 102.885 160.952C103.006 160.89 103.149 160.859 103.313 160.859C103.475 160.859 103.615 160.89 103.733 160.952C103.854 161.013 103.947 161.098 104.012 161.206C104.08 161.314 104.115 161.437 104.117 161.575H103.798C103.798 161.503 103.78 161.433 103.744 161.365C103.708 161.293 103.652 161.236 103.577 161.191C103.505 161.147 103.413 161.125 103.302 161.125C103.164 161.122 103.051 161.158 102.961 161.232C102.874 161.306 102.831 161.408 102.831 161.538C102.831 161.649 102.861 161.733 102.922 161.792C102.984 161.851 103.071 161.901 103.182 161.94C103.294 161.977 103.422 162.02 103.567 162.069C103.687 162.113 103.796 162.165 103.893 162.224C103.989 162.283 104.064 162.359 104.117 162.452C104.173 162.546 104.201 162.665 104.201 162.81C104.201 162.933 104.169 163.05 104.106 163.16C104.044 163.269 103.948 163.357 103.82 163.426C103.695 163.495 103.536 163.529 103.346 163.529Z",
    fill: "white"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M105.784 163.529C105.536 163.529 105.317 163.474 105.129 163.363C104.943 163.25 104.796 163.093 104.69 162.891C104.586 162.69 104.534 162.457 104.534 162.194C104.534 161.931 104.586 161.7 104.69 161.501C104.796 161.299 104.943 161.142 105.129 161.029C105.317 160.916 105.536 160.859 105.784 160.859C106.036 160.859 106.254 160.916 106.44 161.029C106.629 161.142 106.775 161.299 106.879 161.501C106.983 161.7 107.034 161.931 107.034 162.194C107.034 162.457 106.983 162.69 106.879 162.891C106.775 163.093 106.629 163.25 106.44 163.363C106.254 163.474 106.036 163.529 105.784 163.529ZM105.784 163.256C105.97 163.256 106.133 163.215 106.274 163.131C106.416 163.045 106.526 162.923 106.603 162.766C106.683 162.606 106.723 162.416 106.723 162.194C106.723 161.973 106.683 161.784 106.603 161.626C106.526 161.469 106.416 161.349 106.274 161.265C106.133 161.179 105.97 161.136 105.784 161.136C105.598 161.136 105.434 161.179 105.292 161.265C105.152 161.349 105.042 161.469 104.962 161.626C104.885 161.784 104.846 161.973 104.846 162.194C104.846 162.416 104.885 162.606 104.962 162.766C105.042 162.923 105.152 163.045 105.292 163.131C105.434 163.215 105.598 163.256 105.784 163.256Z",
    fill: "white"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M107.474 163.485V160.904H107.778L109.129 162.972V160.904H109.434V163.485H109.129L107.778 161.416V163.485H107.474Z",
    fill: "white"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M111.181 163.485V161.25L110.771 161.342V161.129L111.282 160.904H111.488V163.485H111.181Z",
    fill: "white"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "M112.274 163.485V161.25L111.864 161.342V161.129L112.375 160.904H112.582V163.485H112.274Z",
    fill: "white"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "M99.1562 193.132L99.1474 192.363H91.1314L91.1403 193.132H99.1562Z",
    fill: "#DDC8BA"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "M117.774 193.132L117.756 192.363H100.089L100.107 193.132H117.774Z",
    fill: "#DDC8BA"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "M99.1562 196.745L99.1473 195.977H91.1314L91.1403 196.745H99.1562Z",
    fill: "#DDC8BA"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    d: "M117.774 196.745L117.756 195.977H100.089L100.107 196.745H117.774Z",
    fill: "#DDC8BA"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    d: "M117.774 194.933V194.164H108.576L108.594 194.933H117.774Z",
    fill: "#DDC8BA"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    d: "M107.785 194.933V194.164H91.1314L91.1492 194.933H107.785Z",
    fill: "#DDC8BA"
  })), _ellipse5 || (_ellipse5 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 93.2766,
    cy: 167.799,
    rx: 1.60878,
    ry: 1.60191,
    fill: "url(#paint11_linear_10512_2063)"
  })), _ellipse6 || (_ellipse6 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 93.2766,
    cy: 174.741,
    rx: 1.60878,
    ry: 1.60191,
    fill: "url(#paint12_linear_10512_2063)"
  })), _ellipse7 || (_ellipse7 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 93.2766,
    cy: 181.682,
    rx: 1.60878,
    ry: 1.60191,
    fill: "url(#paint13_linear_10512_2063)"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    d: "M135.926 223.145C137.064 223.145 138.112 221.935 138.272 220.442C138.432 218.949 137.579 217.748 136.024 217.748C134.887 217.748 134.336 218.958 134.167 220.451C134.007 221.944 134.789 223.145 135.926 223.145ZM135.055 220.539C135.144 219.718 135.446 219.047 136.077 219.047C136.93 219.047 137.401 219.709 137.313 220.531C137.224 221.352 136.646 222.023 136.024 222.023C135.402 222.023 134.966 221.361 135.055 220.539Z",
    fill: "url(#paint14_linear_10512_2063)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3
  }, _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    d: "M135.926 223.145C137.064 223.145 138.112 221.935 138.272 220.442C138.432 218.949 137.579 217.748 136.024 217.748C134.887 217.748 134.336 218.958 134.167 220.451C134.007 221.944 134.789 223.145 135.926 223.145ZM135.055 220.539C135.144 219.718 135.446 219.047 136.077 219.047C136.93 219.047 137.401 219.709 137.313 220.531C137.224 221.352 136.646 222.023 136.024 222.023C135.402 222.023 134.966 221.361 135.055 220.539Z",
    fill: "#398191"
  }))), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    d: "M127.032 226.341L135.031 226.318C135.276 226.317 135.474 226.119 135.474 225.875L135.441 215.036C135.44 214.792 135.241 214.595 134.996 214.596L126.997 214.62C126.752 214.62 126.554 214.819 126.554 215.063L126.587 225.901C126.588 226.145 126.787 226.342 127.032 226.341Z",
    fill: "url(#paint15_linear_10512_2063)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3
  }, _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    d: "M132.737 214.611L135.039 214.618C135.279 214.619 135.474 214.814 135.473 215.052L135.441 225.908C135.44 226.147 135.244 226.341 135.004 226.34L132.702 226.333L132.737 214.611Z",
    fill: "#398191"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.5
  }, _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    d: "M127.306 215.187C127.306 215.187 128.879 217.033 128.87 220.646C128.861 224.267 127.315 225.442 127.315 225.442V215.178L127.306 215.187Z",
    fill: "#FFF7E6"
  }))), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    d: "M131.438 214.047C131.847 211.265 126.373 212.599 126.373 210.284C126.373 207.97 134.3 207.97 134.3 206.574C134.3 205.179 129.634 205.824 129.634 204.083C129.634 202.343 135.109 201.654 133.42 199.914C133.42 199.914 134.815 200.665 134.353 201.478C133.891 202.29 132.14 203.271 132.14 204.022C132.14 204.772 137.037 205.064 137.037 206.742C137.037 208.421 129.563 209.286 129.563 210.275C129.563 211.609 133.251 211.088 131.447 214.038L131.438 214.047Z",
    fill: "url(#paint16_linear_10512_2063)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_10512_2063",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 139,
    y: 168,
    width: 53,
    height: 59
  }, _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    d: "M191.949 168.867H139.108V226.345H191.949V168.867Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_10512_2063)"
  }, _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    d: "M174.193 184.326C174.193 186.685 175.402 188.601 176.886 188.601C178.37 188.601 179.578 186.685 179.578 184.326C179.578 181.968 178.37 180.051 176.886 180.051C175.402 180.051 174.193 181.968 174.193 184.326Z",
    fill: "url(#paint17_linear_10512_2063)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5
  }, _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    d: "M174.193 184.326C174.193 186.685 175.402 188.601 176.886 188.601C178.37 188.601 179.578 186.685 179.578 184.326C179.578 181.968 178.37 180.051 176.886 180.051C175.402 180.051 174.193 181.968 174.193 184.326Z",
    fill: "#A69B9B"
  }))), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    d: "M172.504 184.326C172.504 187.232 173.989 189.582 175.819 189.582C177.65 189.582 179.134 187.232 179.134 184.326C179.134 181.42 177.65 179.07 175.819 179.07C173.989 179.07 172.504 181.42 172.504 184.326Z",
    fill: "url(#paint18_linear_10512_2063)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3
  }, _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    d: "M172.504 184.326C172.504 187.232 173.989 189.582 175.819 189.582C177.65 189.582 179.134 187.232 179.134 184.326C179.134 181.42 177.65 179.07 175.819 179.07C173.989 179.07 172.504 181.42 172.504 184.326Z",
    fill: "#463332"
  }))), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    d: "M165.795 191.658H147.372V218.149H165.795V191.658Z",
    fill: "url(#paint19_linear_10512_2063)"
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    d: "M165.795 192.578H148.625V217.223H165.795V192.578Z",
    fill: "#FFF4EE"
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    d: "M159.192 203.148H150.03V203.996H159.192V203.148Z",
    fill: "#DDC8BA"
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    d: "M159.192 206.25H150.03V207.098H159.192V206.25Z",
    fill: "#DDC8BA"
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    d: "M154.926 204.713H150.03V205.561H154.926V204.713Z",
    fill: "#DDC8BA"
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    d: "M164.382 203.148H159.929V203.996H164.382V203.148Z",
    fill: "#DDC8BA"
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    d: "M164.382 204.713H155.664V205.561H164.382V204.713Z",
    fill: "#DDC8BA"
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    d: "M164.382 194.113H150.03V195.836H164.382V194.113Z",
    fill: "#DDC8BA"
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    d: "M159.192 197.398H150.03V198.246H159.192V197.398Z",
    fill: "#DDC8BA"
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    d: "M159.192 200.5H150.03V201.348H159.192V200.5Z",
    fill: "#DDC8BA"
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    d: "M154.926 198.963H150.03V199.811H154.926V198.963Z",
    fill: "#DDC8BA"
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    d: "M164.382 197.398H159.929V198.246H164.382V197.398Z",
    fill: "#DDC8BA"
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    d: "M164.382 198.963H155.664V199.811H164.382V198.963Z",
    fill: "#DDC8BA"
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    d: "M142.982 205.747C144.067 203.326 146.226 200.694 146.759 200.42C146.928 200.332 147.141 200.252 147.355 200.182V202.54C147.355 202.54 147.346 203.079 147.364 203.229C147.47 203.892 148.279 203.468 149.248 203.176C150.136 202.911 150.918 202.982 150.972 203.379C151.007 203.653 150.27 203.927 149.479 204.271C148.679 204.616 147.852 205.641 146.99 205.967C146.128 206.294 145.622 206.4 145.622 206.4C145.622 206.4 144.991 208.291 144.849 208.52L142.085 207.407L142.982 205.738V205.747Z",
    fill: "url(#paint20_linear_10512_2063)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.4
  }, _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    d: "M142.236 207.134L142.138 207.444L144.849 208.539C144.991 208.318 145.622 206.419 145.622 206.419C145.622 206.419 146.137 206.313 146.99 205.986C147.852 205.659 148.679 204.635 149.479 204.29C150.278 203.946 151.007 203.672 150.972 203.398C150.972 203.354 150.927 203.336 150.9 203.301C150.581 203.672 149.479 203.866 149.008 204.122C148.457 204.423 148.092 204.997 147.328 205.553C146.866 205.889 145.853 205.933 145.275 206.074C144.697 206.207 143.764 206.622 142.662 206.322L142.218 207.143L142.236 207.134Z",
    fill: "#C3694D"
  }))), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    d: "M140.521 223.988C137.259 220.428 141.756 206.498 141.756 206.498C141.756 206.498 144.004 205.88 145.524 208.883C145.524 208.883 146.377 218.123 144.884 220.79C143.391 223.458 140.521 223.979 140.521 223.979V223.988Z",
    fill: "url(#paint21_linear_10512_2063)"
  })), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    d: "M172.06 198.353C174.335 197.505 178.485 203.255 183.035 209.474C189.363 218.122 192.26 223.227 189.443 225.551C186.315 228.13 181.764 222.141 176.663 216.117C171.562 210.084 166.31 200.482 172.06 198.353Z",
    fill: "url(#paint22_linear_10512_2063)"
  })), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    d: "M163.475 171.712C163.475 171.712 161.751 170.608 159.592 172.286C156.65 174.574 158.01 178.019 157.601 180.466L162.489 175.21L163.475 171.712Z",
    fill: "url(#paint23_linear_10512_2063)"
  })), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    d: "M170.914 186.871C170.434 188.85 170.265 190.519 170.105 192.842C169.883 196.111 171.616 197.718 171.616 197.718C169.501 198.266 165.59 198.593 163.315 197.471C163.315 197.471 165.102 196.941 164.426 192.454C163.964 189.38 170.905 186.871 170.905 186.871H170.914Z",
    fill: "url(#paint24_linear_10512_2063)"
  })), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    d: "M161.325 173.594C161.112 176.244 165.111 177.631 167.075 178.973C170.096 181.023 169.829 184.476 169.829 184.476L171.758 184.15C171.758 184.15 176.583 185.669 177.792 185.324C178.619 176.102 176.379 171.774 169.75 170.264C163.973 168.947 161.494 171.518 161.325 173.594Z",
    fill: "url(#paint25_linear_10512_2063)"
  })), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    d: "M179.907 232.389C178.352 226.197 178.379 222.973 178.219 217.664C178.076 213.132 178.778 209.449 177.01 202.347C175.668 196.95 170.532 197.294 165.999 197.162C164.169 197.109 161.929 197.639 160.418 198.637C157.032 200.872 154.74 207.806 155.602 210.845C156.49 213.972 158.534 214.166 158.525 218.83C158.525 222.734 156.597 226.541 155.14 232.159C154.882 234.279 171.696 236.929 179.898 232.38L179.907 232.389Z",
    fill: "url(#paint26_linear_10512_2063)"
  })), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    d: "M162.667 197.62C162.667 197.62 164.08 199.475 168.416 199.396C171.411 199.343 173.135 197.903 173.135 197.903C173.135 197.903 168.825 195.748 162.667 197.62Z",
    fill: "url(#paint27_linear_10512_2063)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3
  }, _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    d: "M160.525 218.105C160.436 213.909 158.232 209.713 158.232 209.713L155.895 211.674C156.872 214.05 158.534 214.615 158.525 218.829C158.525 222.733 156.597 226.54 155.139 232.158C155.104 232.441 155.388 232.732 155.904 233.024C157.512 228.643 160.614 222.177 160.525 218.105Z",
    fill: "#A0335D"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.6
  }, _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    d: "M168.55 199.396C171.456 199.307 173.135 197.912 173.135 197.912C173.135 197.912 172.451 197.576 171.242 197.276C170.745 196.604 169.945 195.147 170.105 192.841C170.194 191.552 170.292 190.465 170.434 189.414L164.453 195.668C164.417 195.827 164.373 195.951 164.328 196.092C164.764 196.587 166.292 198.212 168.55 199.396Z",
    fill: "#AC6B53"
  }))), _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    d: "M162.818 198.195C160.365 197.135 155.202 202.611 149.541 208.539C141.676 216.78 137.952 221.718 140.858 224.341C144.084 227.248 149.719 221.559 155.975 215.879C162.231 210.199 168.994 200.889 162.818 198.204V198.195Z",
    fill: "url(#paint28_linear_10512_2063)"
  })), _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    d: "M177.979 180.705C177.979 183.894 180.254 191.393 178.192 193.875C177.206 195.059 173.126 196.234 168.932 196.34C164.8 196.446 160.552 195.492 159.032 194.37C155.966 192.109 158.463 187.003 158.961 182.542C159.459 178.081 161.103 171.889 169.572 172.772C177.054 173.55 177.979 180.705 177.979 180.705Z",
    fill: "url(#paint29_linear_10512_2063)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3
  }, _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    d: "M160.267 180.81C160.267 180.81 160.836 172.834 169.314 172.754C176.886 172.683 177.792 179.609 177.792 179.609C177.792 179.609 177.579 171.014 168.879 171.102C158.801 171.191 158.534 180.307 158.534 180.307L160.267 180.801V180.81Z",
    fill: "#491D17"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3
  }, _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    d: "M158.472 179.044C158.197 179.044 157.93 179.097 157.672 179.185C157.672 179.636 157.664 180.069 157.592 180.466L158.863 179.097C158.73 179.07 158.606 179.035 158.463 179.035L158.472 179.044Z",
    fill: "#491D17"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3
  }, _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    d: "M158.472 190.404C160.489 190.404 162.116 187.86 162.116 184.724C162.116 182.189 161.04 180.06 159.565 179.336C159.263 180.422 159.076 181.527 158.961 182.551C158.677 185.113 157.735 187.887 157.566 190.21C157.859 190.325 158.161 190.413 158.472 190.413V190.404Z",
    fill: "#491D17"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3
  }, _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    d: "M177.979 180.705C177.979 180.705 177.952 180.546 177.899 180.289C177.676 176.889 176.708 174.477 174.913 172.799C176.468 175.36 176.45 178.77 171.171 179.397C161.929 180.493 158.436 175.74 158.596 173.329C157.006 175.537 157.948 178.381 157.601 180.475L160.072 177.816C159.432 179.371 159.13 181.049 158.97 182.542C158.472 187.003 155.975 192.1 159.041 194.37C160.56 195.492 164.808 196.446 168.941 196.34C173.135 196.234 177.214 195.05 178.201 193.875C180.263 191.393 177.987 183.893 177.987 180.705H177.979Z",
    fill: "#491D17"
  }))), _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
    d: "M159.814 180.21C159.814 180.21 160.4 172.234 169.092 172.154C176.859 172.084 177.783 179.009 177.783 179.009C177.783 179.009 177.561 170.414 168.638 170.503C158.303 170.591 158.028 179.707 158.028 179.707L159.805 180.202L159.814 180.21Z",
    fill: "url(#paint30_linear_10512_2063)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3
  }, _path154 || (_path154 = /*#__PURE__*/React.createElement("path", {
    d: "M168.985 171.616C160.587 171.695 159.37 179.08 159.254 180.052L159.823 180.211C159.823 180.211 160.409 172.234 169.101 172.155C176.868 172.084 177.792 179.009 177.792 179.009C177.792 179.009 177.668 177.472 176.886 175.706C175.748 173.762 173.473 171.572 168.985 171.616Z",
    fill: "#463332"
  }))), _path155 || (_path155 = /*#__PURE__*/React.createElement("path", {
    d: "M158.143 189.555C159.974 189.555 161.458 187.201 161.458 184.299C161.458 181.396 159.974 179.043 158.143 179.043C156.312 179.043 154.828 181.396 154.828 184.299C154.828 187.201 156.312 189.555 158.143 189.555Z",
    fill: "url(#paint31_linear_10512_2063)"
  })), _path156 || (_path156 = /*#__PURE__*/React.createElement("path", {
    d: "M159.734 184.326C159.734 186.685 158.525 188.601 157.041 188.601C155.557 188.601 154.349 186.685 154.349 184.326C154.349 181.968 155.557 180.051 157.041 180.051C158.525 180.051 159.734 181.968 159.734 184.326Z",
    fill: "url(#paint32_linear_10512_2063)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3
  }, _path157 || (_path157 = /*#__PURE__*/React.createElement("path", {
    d: "M158.143 179.043C158.063 179.043 158.001 179.069 157.921 179.078C159.467 179.405 160.658 181.49 160.658 184.025C160.658 186.799 159.245 189.042 157.494 189.042C157.068 189.042 156.659 188.901 156.286 188.654C156.819 189.219 157.45 189.555 158.143 189.555C159.974 189.555 161.458 187.205 161.458 184.299C161.458 181.393 159.974 179.043 158.143 179.043Z",
    fill: "#463332"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5
  }, _path158 || (_path158 = /*#__PURE__*/React.createElement("path", {
    d: "M157.041 180.051C156.544 180.051 156.081 180.28 155.673 180.66C155.921 180.519 156.179 180.422 156.464 180.422C157.717 180.422 158.739 182.038 158.739 184.035C158.739 186.031 157.717 187.647 156.464 187.647C155.664 187.647 154.962 186.985 154.553 185.987C154.962 187.533 155.921 188.61 157.041 188.61C158.534 188.61 159.734 186.693 159.734 184.335C159.734 181.976 158.525 180.06 157.041 180.06V180.051Z",
    fill: "#A69B9B"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.4
  }, _path159 || (_path159 = /*#__PURE__*/React.createElement("path", {
    d: "M156.561 181.139C157.814 181.351 156.321 183.568 155.655 183.471C154.615 183.321 155.468 180.954 156.561 181.139Z",
    fill: "#FFF7E6"
  })), _path160 || (_path160 = /*#__PURE__*/React.createElement("path", {
    d: "M155.264 183.816C156.046 183.692 155.753 184.849 155.379 184.894C154.802 184.964 154.651 183.913 155.264 183.816Z",
    fill: "#FFF7E6"
  }))), _path161 || (_path161 = /*#__PURE__*/React.createElement("path", {
    d: "M188.749 219.908C188.003 232.593 183.408 239.889 174.246 239.889C165.084 239.889 161.342 232.593 162.089 219.908C162.835 207.224 166.257 193.965 176.948 193.965C187.639 193.965 189.505 207.224 188.758 219.908H188.749Z",
    fill: "url(#paint33_linear_10512_2063)"
  })), _path162 || (_path162 = /*#__PURE__*/React.createElement("path", {
    d: "M190.767 219.908C190.02 232.593 185.426 239.889 176.263 239.889C167.101 239.889 163.36 232.593 164.106 219.908C164.853 207.224 168.274 193.965 178.965 193.965C189.656 193.965 191.522 207.224 190.776 219.908H190.767Z",
    fill: "url(#paint34_linear_10512_2063)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3
  }, _path163 || (_path163 = /*#__PURE__*/React.createElement("path", {
    d: "M183.089 194.814C188.376 198.762 189.363 208.593 188.803 218.116C188.083 230.394 183.631 237.461 174.753 237.461C170.576 237.461 167.581 235.879 165.635 232.938C167.492 237.443 170.967 239.89 176.255 239.89C185.417 239.89 190.02 232.593 190.758 219.909C191.389 209.088 190.109 197.87 183.08 194.805L183.089 194.814Z",
    fill: "#463332"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3
  }, _path164 || (_path164 = /*#__PURE__*/React.createElement("path", {
    d: "M159.378 212.451C159.378 212.451 160.489 209.783 160.223 209.138C160.223 209.138 156.161 213.317 155.539 213.873C149.861 219.032 144.449 225.038 141.525 222.397C138.841 219.977 141.009 210.79 142.298 206.453C141.96 206.453 141.756 206.506 141.756 206.506C141.756 206.506 137.499 219.721 140.307 223.678C140.352 223.749 140.396 223.828 140.45 223.899C140.476 223.925 140.485 223.97 140.512 223.996H140.529C140.627 224.12 140.725 224.235 140.849 224.349C144.075 227.255 149.71 221.567 155.966 215.887C156.659 215.26 158.525 213.44 159.378 212.46V212.451Z",
    fill: "#A0335D"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.2
  }, _path165 || (_path165 = /*#__PURE__*/React.createElement("path", {
    d: "M145.719 212.302C145.648 210.367 145.515 208.892 145.515 208.892C144.004 205.88 141.747 206.507 141.747 206.507C141.747 206.507 137.25 220.437 140.512 223.997C138.619 220.305 143.942 214.554 145.648 212.735L145.711 212.311L145.719 212.302Z",
    fill: "#A0335D"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.4
  }, _path166 || (_path166 = /*#__PURE__*/React.createElement("path", {
    d: "M147.87 203.581C147.87 203.581 147.87 203.581 147.879 203.581C147.603 203.608 147.417 203.528 147.372 203.237C147.346 203.087 147.372 202.548 147.372 202.548V201.152C147.292 201.214 146.501 201.965 146.546 202.663C146.599 203.493 147.204 203.705 147.87 203.59V203.581Z",
    fill: "#C3694D"
  })))), _path167 || (_path167 = /*#__PURE__*/React.createElement("path", {
    d: "M67.9597 224.819V219.528H67.0177V218H110.439C111.194 218 111.807 218.609 111.807 219.36V224.996C111.807 225.747 111.194 226.356 110.439 226.356H67.0177V224.828H67.9597V224.819Z",
    fill: "url(#paint35_linear_10512_2063)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3
  }, _path168 || (_path168 = /*#__PURE__*/React.createElement("path", {
    d: "M110.439 217.999H90.6033V226.347H110.439C111.194 226.347 111.807 225.737 111.807 224.986V219.351C111.807 218.6 111.194 217.99 110.439 217.99V217.999Z",
    fill: "#60578F"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3
  }, _path169 || (_path169 = /*#__PURE__*/React.createElement("path", {
    d: "M109.763 224.818H69.115V219.527H109.763C110.243 219.527 110.625 219.916 110.625 220.384V223.953C110.625 224.43 110.234 224.81 109.763 224.81V224.818Z",
    fill: "#60578F"
  }))), _path170 || (_path170 = /*#__PURE__*/React.createElement("path", {
    d: "M108.608 224.818H67.9598V219.527H108.608C109.088 219.527 109.47 219.916 109.47 220.384V223.953C109.47 224.43 109.079 224.81 108.608 224.81V224.818Z",
    fill: "#CEB6AA"
  })), _path171 || (_path171 = /*#__PURE__*/React.createElement("path", {
    d: "M89.697 219.527H67.9598V224.818H89.697V219.527Z",
    fill: "#CEB6AA"
  })), _path172 || (_path172 = /*#__PURE__*/React.createElement("path", {
    d: "M89.697 219.527H67.9598V224.818H89.697V219.527Z",
    fill: "#FFE6D6"
  })), _path173 || (_path173 = /*#__PURE__*/React.createElement("path", {
    d: "M88.9594 219.527H108.599C109.079 219.527 109.461 219.916 109.461 220.384V221.603C109.461 221.126 109.07 220.746 108.599 220.746H88.9594V219.527Z",
    fill: "#B29B93"
  })), _path174 || (_path174 = /*#__PURE__*/React.createElement("path", {
    d: "M108.004 221.823C108.004 221.823 107.435 221.867 106.573 221.911C105.711 221.956 104.565 221.973 103.418 221.982C102.272 221.973 101.125 221.956 100.263 221.911C99.4013 221.867 98.8326 221.823 98.8326 221.823C98.8326 221.823 99.4102 221.779 100.263 221.735C101.125 221.691 102.272 221.673 103.418 221.664C104.565 221.673 105.711 221.691 106.573 221.735C107.435 221.779 108.004 221.823 108.004 221.823Z",
    fill: "#B29B93"
  })), _path175 || (_path175 = /*#__PURE__*/React.createElement("path", {
    d: "M105.276 223.846C105.276 223.846 104.431 223.882 103.178 223.935C101.916 223.979 100.237 223.997 98.5571 224.005C96.8775 223.997 95.1979 223.979 93.936 223.935C92.6741 223.882 91.8387 223.846 91.8387 223.846C91.8387 223.846 92.683 223.811 93.936 223.758C95.1979 223.714 96.8775 223.696 98.5571 223.688C100.237 223.696 101.916 223.714 103.178 223.758C104.44 223.811 105.276 223.846 105.276 223.846Z",
    fill: "#B29B93"
  })), _path176 || (_path176 = /*#__PURE__*/React.createElement("path", {
    d: "M88.6128 222.798C88.6128 222.798 87.5375 222.833 85.929 222.877C84.3204 222.912 82.1787 222.93 80.037 222.939C77.8953 222.93 75.7447 222.912 74.145 222.877C72.5365 222.833 71.4612 222.798 71.4612 222.798C71.4612 222.798 72.5365 222.762 74.145 222.718C75.7535 222.683 77.8953 222.665 80.037 222.656C82.1787 222.665 84.3293 222.683 85.929 222.718C87.5375 222.762 88.6128 222.798 88.6128 222.798Z",
    fill: "#CEB6AA"
  })), _path177 || (_path177 = /*#__PURE__*/React.createElement("path", {
    d: "M76.2245 221.551C76.2245 221.551 75.7624 221.596 75.0781 221.631C74.3939 221.666 73.4696 221.684 72.5543 221.693C71.6389 221.684 70.7236 221.666 70.0304 221.631C69.3461 221.596 68.884 221.551 68.884 221.551C68.884 221.551 69.3461 221.507 70.0304 221.472C70.7147 221.437 71.6389 221.419 72.5543 221.41C73.4696 221.419 74.385 221.437 75.0781 221.472C75.7624 221.507 76.2245 221.551 76.2245 221.551Z",
    fill: "#CEB6AA"
  })), _path178 || (_path178 = /*#__PURE__*/React.createElement("path", {
    d: "M85.8312 223.901C85.8312 223.901 85.1291 223.936 84.0805 223.981C83.0318 224.016 81.6277 224.034 80.2325 224.042C78.8284 224.034 77.4331 224.016 76.3845 223.981C75.3359 223.936 74.6338 223.901 74.6338 223.901L76.3845 223.822C77.4331 223.786 78.8373 223.769 80.2325 223.76C81.6366 223.769 83.0318 223.786 84.0805 223.822C85.1291 223.866 85.8312 223.901 85.8312 223.901Z",
    fill: "#CEB6AA"
  })), _path179 || (_path179 = /*#__PURE__*/React.createElement("path", {
    d: "M89.697 219.527H67.9598V220.729H89.697V219.527Z",
    fill: "#CEB6AA"
  })), _path180 || (_path180 = /*#__PURE__*/React.createElement("path", {
    d: "M104.734 213.502V210.225H105.48V209.023H71.2924C70.697 209.023 70.2171 209.5 70.2171 210.092V213.643C70.2171 214.235 70.697 214.712 71.2924 214.712H105.48V213.511H104.734V213.502Z",
    fill: "url(#paint36_linear_10512_2063)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3
  }, _path181 || (_path181 = /*#__PURE__*/React.createElement("path", {
    d: "M71.8256 210.224H103.827V213.501H71.8256C71.4524 213.501 71.1414 213.2 71.1414 212.821V210.895C71.1414 210.524 71.4435 210.215 71.8256 210.215V210.224Z",
    fill: "#A0335D"
  }))), _path182 || (_path182 = /*#__PURE__*/React.createElement("path", {
    d: "M72.7321 210.224H104.734V213.501H72.7321C72.3588 213.501 72.0478 213.2 72.0478 212.821V210.895C72.0478 210.524 72.3499 210.215 72.7321 210.215V210.224Z",
    fill: "#FFE6D6"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3
  }, _path183 || (_path183 = /*#__PURE__*/React.createElement("path", {
    d: "M105.48 210.225V209.023H88.0352V214.712H105.48V213.511H104.734V210.234H105.48V210.225Z",
    fill: "#A0335D"
  }))), _path184 || (_path184 = /*#__PURE__*/React.createElement("path", {
    d: "M104.734 210.225H87.6175V213.502H104.734V210.225Z",
    fill: "#CEB6AA"
  })), _path185 || (_path185 = /*#__PURE__*/React.createElement("path", {
    d: "M104.734 210.225H87.6175V213.502H104.734V210.225Z",
    fill: "#CEB6AA"
  })), _path186 || (_path186 = /*#__PURE__*/React.createElement("path", {
    d: "M88.1951 210.225H72.7321C72.3588 210.225 72.0478 210.525 72.0478 210.905V211.868C72.0478 211.497 72.3499 211.187 72.7321 211.187H88.1951V210.225Z",
    fill: "#CEB6AA"
  })), _path187 || (_path187 = /*#__PURE__*/React.createElement("path", {
    d: "M73.2032 211.849L74.3318 211.779C75.0072 211.743 75.9136 211.734 76.8112 211.717C77.7177 211.726 78.6152 211.734 79.2906 211.77C79.966 211.814 80.4193 211.84 80.4193 211.84C80.4193 211.84 79.966 211.867 79.2906 211.911C78.6152 211.946 77.7088 211.955 76.8112 211.964C75.9048 211.955 75.0072 211.946 74.3318 211.902C73.6564 211.858 73.2032 211.832 73.2032 211.832V211.849Z",
    fill: "#CEB6AA"
  })), _path188 || (_path188 = /*#__PURE__*/React.createElement("path", {
    d: "M75.3537 212.732C75.3537 212.732 76.0113 212.706 77.0066 212.661C78.0019 212.626 79.3172 212.617 80.6413 212.6C81.9655 212.608 83.2896 212.617 84.276 212.653C85.2714 212.697 85.929 212.723 85.929 212.723C85.929 212.723 85.2714 212.75 84.276 212.794C83.2807 212.829 81.9655 212.838 80.6413 212.847C79.3172 212.838 77.9931 212.829 77.0066 212.785C76.0113 212.741 75.3537 212.714 75.3537 212.714V212.732Z",
    fill: "#CEB6AA"
  })), _path189 || (_path189 = /*#__PURE__*/React.createElement("path", {
    d: "M88.4707 211.913C88.4707 211.913 89.3149 211.877 90.5769 211.833C91.8388 211.789 93.5273 211.78 95.2158 211.771C96.9043 211.78 98.5928 211.798 99.8547 211.833C101.117 211.886 101.961 211.913 101.961 211.913C101.961 211.913 101.117 211.948 99.8547 211.992C98.5928 212.036 96.9043 212.045 95.2158 212.054C93.5273 212.045 91.8388 212.028 90.5769 211.992C89.3149 211.939 88.4707 211.913 88.4707 211.913Z",
    fill: "#B29B93"
  })), _path190 || (_path190 = /*#__PURE__*/React.createElement("path", {
    d: "M93.7584 212.769C93.7584 212.769 95.9623 212.636 98.1662 212.645C100.37 212.636 102.574 212.769 102.574 212.769C102.574 212.769 100.37 212.901 98.1662 212.892C95.9623 212.901 93.7584 212.769 93.7584 212.769Z",
    fill: "#B29B93"
  })), _path191 || (_path191 = /*#__PURE__*/React.createElement("path", {
    d: "M104.734 210.225H87.6175V211.17H104.734V210.225Z",
    fill: "#B29B93"
  })), _path192 || (_path192 = /*#__PURE__*/React.createElement("path", {
    d: "M67.6843 217.274V215.463H67V214.668H110.812C111.354 214.668 111.798 215.039 111.798 215.498V217.238C111.798 217.698 111.354 218.069 110.812 218.069H67V217.274H67.6843Z",
    fill: "url(#paint37_linear_10512_2063)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.2
  }, _path193 || (_path193 = /*#__PURE__*/React.createElement("path", {
    d: "M110.812 214.668H89.1282V218.069H110.812C111.354 218.069 111.798 217.698 111.798 217.238V215.498C111.798 215.039 111.354 214.668 110.812 214.668Z",
    fill: "#AA2424"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.2
  }, _path194 || (_path194 = /*#__PURE__*/React.createElement("path", {
    d: "M110.332 217.273H68.5285V215.463H110.332C110.679 215.463 110.954 215.745 110.954 216.081V216.655C110.954 217 110.67 217.273 110.332 217.273Z",
    fill: "#AA2424"
  }))), _path195 || (_path195 = /*#__PURE__*/React.createElement("path", {
    d: "M109.497 217.273H67.6932V215.463H109.497C109.843 215.463 110.119 215.745 110.119 216.081V216.655C110.119 217 109.835 217.273 109.497 217.273Z",
    fill: "#CEB6AA"
  })), _path196 || (_path196 = /*#__PURE__*/React.createElement("path", {
    d: "M89.5192 215.463H67.6843V217.274H89.5192V215.463Z",
    fill: "#CEB6AA"
  })), _path197 || (_path197 = /*#__PURE__*/React.createElement("path", {
    d: "M89.5192 215.463H67.6843V217.274H89.5192V215.463Z",
    fill: "#FFE6D6"
  })), _path198 || (_path198 = /*#__PURE__*/React.createElement("path", {
    d: "M88.9861 215.463H109.497C109.843 215.463 110.119 215.746 110.119 216.081V216.965C110.119 216.62 109.835 216.346 109.497 216.346H88.9861V215.463Z",
    fill: "#B29B93"
  })), _path199 || (_path199 = /*#__PURE__*/React.createElement("path", {
    d: "M89.5192 215.463H67.6843V216.329H89.5192V215.463Z",
    fill: "#CEB6AA"
  })), _path200 || (_path200 = /*#__PURE__*/React.createElement("path", {
    d: "M27.62 63V51.06H23.54V49H34.28V51.06H30.18V63H27.62ZM38.9195 63.24C37.9195 63.24 37.0329 63.0267 36.2595 62.6C35.4862 62.1733 34.8795 61.5733 34.4395 60.8C33.9995 60.0267 33.7795 59.1333 33.7795 58.12C33.7795 57.0933 33.9929 56.18 34.4195 55.38C34.8595 54.58 35.4595 53.96 36.2195 53.52C36.9929 53.0667 37.8995 52.84 38.9395 52.84C39.9129 52.84 40.7729 53.0533 41.5195 53.48C42.2662 53.9067 42.8462 54.4933 43.2595 55.24C43.6862 55.9733 43.8995 56.7933 43.8995 57.7C43.8995 57.8467 43.8929 58 43.8795 58.16C43.8795 58.32 43.8729 58.4867 43.8595 58.66H36.3195C36.3729 59.4333 36.6395 60.04 37.1195 60.48C37.6129 60.92 38.2062 61.14 38.8995 61.14C39.4195 61.14 39.8529 61.0267 40.1995 60.8C40.5595 60.56 40.8262 60.2533 40.9995 59.88H43.5995C43.4129 60.5067 43.0995 61.08 42.6595 61.6C42.2329 62.1067 41.6995 62.5067 41.0595 62.8C40.4329 63.0933 39.7195 63.24 38.9195 63.24ZM38.9395 54.92C38.3129 54.92 37.7595 55.1 37.2795 55.46C36.7995 55.8067 36.4929 56.34 36.3595 57.06H41.2995C41.2595 56.4067 41.0195 55.8867 40.5795 55.5C40.1395 55.1133 39.5929 54.92 38.9395 54.92ZM49.2527 63.24C48.3993 63.24 47.6993 63.1067 47.1527 62.84C46.606 62.56 46.1993 62.1933 45.9327 61.74C45.666 61.2867 45.5327 60.7867 45.5327 60.24C45.5327 59.32 45.8927 58.5733 46.6127 58C47.3327 57.4267 48.4127 57.14 49.8527 57.14H52.3727V56.9C52.3727 56.22 52.1793 55.72 51.7927 55.4C51.406 55.08 50.926 54.92 50.3527 54.92C49.8327 54.92 49.3793 55.0467 48.9927 55.3C48.606 55.54 48.366 55.9 48.2727 56.38H45.7727C45.8393 55.66 46.0793 55.0333 46.4927 54.5C46.9193 53.9667 47.466 53.56 48.1327 53.28C48.7993 52.9867 49.546 52.84 50.3727 52.84C51.786 52.84 52.8993 53.1933 53.7127 53.9C54.526 54.6067 54.9327 55.6067 54.9327 56.9V63H52.7527L52.5127 61.4C52.2193 61.9333 51.806 62.3733 51.2727 62.72C50.7527 63.0667 50.0793 63.24 49.2527 63.24ZM49.8327 61.24C50.566 61.24 51.1327 61 51.5327 60.52C51.946 60.04 52.206 59.4467 52.3127 58.74H50.1327C49.4527 58.74 48.966 58.8667 48.6727 59.12C48.3793 59.36 48.2327 59.66 48.2327 60.02C48.2327 60.4067 48.3793 60.7067 48.6727 60.92C48.966 61.1333 49.3527 61.24 49.8327 61.24ZM62.0156 63.24C61.0023 63.24 60.109 63.02 59.3356 62.58C58.5623 62.14 57.949 61.5267 57.4956 60.74C57.0556 59.9533 56.8356 59.0533 56.8356 58.04C56.8356 57.0267 57.0556 56.1267 57.4956 55.34C57.949 54.5533 58.5623 53.94 59.3356 53.5C60.109 53.06 61.0023 52.84 62.0156 52.84C63.2823 52.84 64.349 53.1733 65.2156 53.84C66.0823 54.4933 66.6356 55.4 66.8756 56.56H64.1756C64.0423 56.08 63.7756 55.7067 63.3756 55.44C62.989 55.16 62.529 55.02 61.9956 55.02C61.289 55.02 60.689 55.2867 60.1956 55.82C59.7023 56.3533 59.4556 57.0933 59.4556 58.04C59.4556 58.9867 59.7023 59.7267 60.1956 60.26C60.689 60.7933 61.289 61.06 61.9956 61.06C62.529 61.06 62.989 60.9267 63.3756 60.66C63.7756 60.3933 64.0423 60.0133 64.1756 59.52H66.8756C66.6356 60.64 66.0823 61.54 65.2156 62.22C64.349 62.9 63.2823 63.24 62.0156 63.24ZM68.9278 63V48.6H71.4878V54.6C71.8211 54.0533 72.2678 53.6267 72.8278 53.32C73.4011 53 74.0545 52.84 74.7878 52.84C76.0145 52.84 76.9611 53.2267 77.6278 54C78.3078 54.7733 78.6478 55.9067 78.6478 57.4V63H76.1078V57.64C76.1078 56.7867 75.9345 56.1333 75.5878 55.68C75.2545 55.2267 74.7211 55 73.9878 55C73.2678 55 72.6678 55.2533 72.1878 55.76C71.7211 56.2667 71.4878 56.9733 71.4878 57.88V63H68.9278ZM85.6958 63.24C84.6958 63.24 83.8091 63.0267 83.0358 62.6C82.2624 62.1733 81.6558 61.5733 81.2158 60.8C80.7758 60.0267 80.5558 59.1333 80.5558 58.12C80.5558 57.0933 80.7691 56.18 81.1958 55.38C81.6358 54.58 82.2358 53.96 82.9958 53.52C83.7691 53.0667 84.6758 52.84 85.7158 52.84C86.6891 52.84 87.5491 53.0533 88.2958 53.48C89.0424 53.9067 89.6224 54.4933 90.0358 55.24C90.4624 55.9733 90.6758 56.7933 90.6758 57.7C90.6758 57.8467 90.6691 58 90.6558 58.16C90.6558 58.32 90.6491 58.4867 90.6358 58.66H83.0958C83.1491 59.4333 83.4158 60.04 83.8958 60.48C84.3891 60.92 84.9824 61.14 85.6758 61.14C86.1958 61.14 86.6291 61.0267 86.9758 60.8C87.3358 60.56 87.6024 60.2533 87.7758 59.88H90.3758C90.1891 60.5067 89.8758 61.08 89.4358 61.6C89.0091 62.1067 88.4758 62.5067 87.8358 62.8C87.2091 63.0933 86.4958 63.24 85.6958 63.24ZM85.7158 54.92C85.0891 54.92 84.5358 55.1 84.0558 55.46C83.5758 55.8067 83.2691 56.34 83.1358 57.06H88.0758C88.0358 56.4067 87.7958 55.8867 87.3558 55.5C86.9158 55.1133 86.3691 54.92 85.7158 54.92ZM92.6089 63V53.08H94.8889L95.1289 54.94C95.4889 54.3 95.9756 53.7933 96.5889 53.42C97.2156 53.0333 97.9489 52.84 98.7889 52.84V55.54H98.0689C97.5089 55.54 97.0089 55.6267 96.5689 55.8C96.1289 55.9733 95.7822 56.2733 95.5289 56.7C95.2889 57.1267 95.1689 57.72 95.1689 58.48V63H92.6089ZM30.7 89.24C29.2867 89.24 28.0733 88.94 27.06 88.34C26.0467 87.7267 25.2667 86.88 24.72 85.8C24.1733 84.7067 23.9 83.4467 23.9 82.02C23.9 80.5933 24.1733 79.3333 24.72 78.24C25.2667 77.1467 26.0467 76.2933 27.06 75.68C28.0733 75.0667 29.2867 74.76 30.7 74.76C32.38 74.76 33.7533 75.18 34.82 76.02C35.9 76.8467 36.5733 78.0133 36.84 79.52H34.02C33.8467 78.76 33.4733 78.1667 32.9 77.74C32.34 77.3 31.5933 77.08 30.66 77.08C29.3667 77.08 28.3533 77.52 27.62 78.4C26.8867 79.28 26.52 80.4867 26.52 82.02C26.52 83.5533 26.8867 84.76 27.62 85.64C28.3533 86.5067 29.3667 86.94 30.66 86.94C31.5933 86.94 32.34 86.74 32.9 86.34C33.4733 85.9267 33.8467 85.36 34.02 84.64H36.84C36.5733 86.08 35.9 87.2067 34.82 88.02C33.7533 88.8333 32.38 89.24 30.7 89.24ZM42.2461 89.24C41.3928 89.24 40.6928 89.1067 40.1461 88.84C39.5994 88.56 39.1928 88.1933 38.9261 87.74C38.6594 87.2867 38.5261 86.7867 38.5261 86.24C38.5261 85.32 38.8861 84.5733 39.6061 84C40.3261 83.4267 41.4061 83.14 42.8461 83.14H45.3661V82.9C45.3661 82.22 45.1728 81.72 44.7861 81.4C44.3994 81.08 43.9194 80.92 43.3461 80.92C42.8261 80.92 42.3728 81.0467 41.9861 81.3C41.5994 81.54 41.3594 81.9 41.2661 82.38H38.7661C38.8328 81.66 39.0728 81.0333 39.4861 80.5C39.9128 79.9667 40.4594 79.56 41.1261 79.28C41.7928 78.9867 42.5394 78.84 43.3661 78.84C44.7794 78.84 45.8928 79.1933 46.7061 79.9C47.5194 80.6067 47.9261 81.6067 47.9261 82.9V89H45.7461L45.5061 87.4C45.2128 87.9333 44.7994 88.3733 44.2661 88.72C43.7461 89.0667 43.0728 89.24 42.2461 89.24ZM42.8261 87.24C43.5594 87.24 44.1261 87 44.5261 86.52C44.9394 86.04 45.1994 85.4467 45.3061 84.74H43.1261C42.4461 84.74 41.9594 84.8667 41.6661 85.12C41.3728 85.36 41.2261 85.66 41.2261 86.02C41.2261 86.4067 41.3728 86.7067 41.6661 86.92C41.9594 87.1333 42.3461 87.24 42.8261 87.24ZM50.1491 93.4V79.08H52.4291L52.7091 80.5C53.0291 80.06 53.4491 79.6733 53.9691 79.34C54.5024 79.0067 55.1891 78.84 56.0291 78.84C56.9624 78.84 57.7957 79.0667 58.5291 79.52C59.2624 79.9733 59.8424 80.5933 60.2691 81.38C60.6957 82.1667 60.9091 83.06 60.9091 84.06C60.9091 85.06 60.6957 85.9533 60.2691 86.74C59.8424 87.5133 59.2624 88.1267 58.5291 88.58C57.7957 89.02 56.9624 89.24 56.0291 89.24C55.2824 89.24 54.6291 89.1 54.0691 88.82C53.5091 88.54 53.0557 88.1467 52.7091 87.64V93.4H50.1491ZM55.4891 87C56.3024 87 56.9757 86.7267 57.5091 86.18C58.0424 85.6333 58.3091 84.9267 58.3091 84.06C58.3091 83.1933 58.0424 82.48 57.5091 81.92C56.9757 81.36 56.3024 81.08 55.4891 81.08C54.6624 81.08 53.9824 81.36 53.4491 81.92C52.9291 82.4667 52.6691 83.1733 52.6691 84.04C52.6691 84.9067 52.9291 85.62 53.4491 86.18C53.9824 86.7267 54.6624 87 55.4891 87ZM66.3959 89.24C65.5426 89.24 64.8426 89.1067 64.2959 88.84C63.7493 88.56 63.3426 88.1933 63.0759 87.74C62.8093 87.2867 62.6759 86.7867 62.6759 86.24C62.6759 85.32 63.0359 84.5733 63.7559 84C64.4759 83.4267 65.5559 83.14 66.9959 83.14H69.5159V82.9C69.5159 82.22 69.3226 81.72 68.9359 81.4C68.5493 81.08 68.0693 80.92 67.4959 80.92C66.9759 80.92 66.5226 81.0467 66.1359 81.3C65.7493 81.54 65.5093 81.9 65.4159 82.38H62.9159C62.9826 81.66 63.2226 81.0333 63.6359 80.5C64.0626 79.9667 64.6093 79.56 65.2759 79.28C65.9426 78.9867 66.6893 78.84 67.5159 78.84C68.9293 78.84 70.0426 79.1933 70.8559 79.9C71.6693 80.6067 72.0759 81.6067 72.0759 82.9V89H69.8959L69.6559 87.4C69.3626 87.9333 68.9493 88.3733 68.4159 88.72C67.8959 89.0667 67.2226 89.24 66.3959 89.24ZM66.9759 87.24C67.7093 87.24 68.2759 87 68.6759 86.52C69.0893 86.04 69.3493 85.4467 69.4559 84.74H67.2759C66.5959 84.74 66.1093 84.8667 65.8159 85.12C65.5226 85.36 65.3759 85.66 65.3759 86.02C65.3759 86.4067 65.5226 86.7067 65.8159 86.92C66.1093 87.1333 66.4959 87.24 66.9759 87.24ZM80.1789 89.24C79.4322 89.24 78.7789 89.1 78.2189 88.82C77.6589 88.54 77.2056 88.1467 76.8589 87.64L76.5789 89H74.2989V74.6H76.8589V80.5C77.1789 80.06 77.5989 79.6733 78.1189 79.34C78.6522 79.0067 79.3389 78.84 80.1789 78.84C81.1122 78.84 81.9456 79.0667 82.6789 79.52C83.4122 79.9733 83.9922 80.5933 84.4189 81.38C84.8456 82.1667 85.0589 83.06 85.0589 84.06C85.0589 85.06 84.8456 85.9533 84.4189 86.74C83.9922 87.5133 83.4122 88.1267 82.6789 88.58C81.9456 89.02 81.1122 89.24 80.1789 89.24ZM79.6389 87C80.4522 87 81.1256 86.7267 81.6589 86.18C82.1922 85.6333 82.4589 84.9267 82.4589 84.06C82.4589 83.1933 82.1922 82.48 81.6589 81.92C81.1256 81.36 80.4522 81.08 79.6389 81.08C78.8122 81.08 78.1322 81.36 77.5989 81.92C77.0789 82.4667 76.8189 83.1733 76.8189 84.04C76.8189 84.9067 77.0789 85.62 77.5989 86.18C78.1322 86.7267 78.8122 87 79.6389 87ZM88.5058 77.54C88.0391 77.54 87.6524 77.4 87.3458 77.12C87.0524 76.84 86.9058 76.4867 86.9058 76.06C86.9058 75.6333 87.0524 75.2867 87.3458 75.02C87.6524 74.74 88.0391 74.6 88.5058 74.6C88.9724 74.6 89.3524 74.74 89.6458 75.02C89.9524 75.2867 90.1058 75.6333 90.1058 76.06C90.1058 76.4867 89.9524 76.84 89.6458 77.12C89.3524 77.4 88.9724 77.54 88.5058 77.54ZM87.2258 89V79.08H89.7858V89H87.2258ZM92.2378 89V74.6H94.7978V89H92.2378ZM98.5736 77.54C98.1069 77.54 97.7203 77.4 97.4136 77.12C97.1203 76.84 96.9736 76.4867 96.9736 76.06C96.9736 75.6333 97.1203 75.2867 97.4136 75.02C97.7203 74.74 98.1069 74.6 98.5736 74.6C99.0403 74.6 99.4203 74.74 99.7136 75.02C100.02 75.2867 100.174 75.6333 100.174 76.06C100.174 76.4867 100.02 76.84 99.7136 77.12C99.4203 77.4 99.0403 77.54 98.5736 77.54ZM97.2936 89V79.08H99.8536V89H97.2936ZM106.726 89C105.686 89 104.852 88.7467 104.226 88.24C103.599 87.7333 103.286 86.8333 103.286 85.54V81.22H101.586V79.08H103.286L103.586 76.42H105.846V79.08H108.526V81.22H105.846V85.56C105.846 86.04 105.946 86.3733 106.146 86.56C106.359 86.7333 106.719 86.82 107.226 86.82H108.466V89H106.726ZM111.744 93.4L114.044 88.34H113.444L109.584 79.08H112.364L115.144 86.06L118.044 79.08H120.764L114.464 93.4H111.744ZM29.14 115.24C28.1133 115.24 27.2067 115.067 26.42 114.72C25.6333 114.36 25.0133 113.853 24.56 113.2C24.1067 112.533 23.8733 111.727 23.86 110.78H26.56C26.5867 111.433 26.82 111.987 27.26 112.44C27.7133 112.88 28.3333 113.1 29.12 113.1C29.8 113.1 30.34 112.94 30.74 112.62C31.14 112.287 31.34 111.847 31.34 111.3C31.34 110.727 31.16 110.28 30.8 109.96C30.4533 109.64 29.9867 109.38 29.4 109.18C28.8133 108.98 28.1867 108.767 27.52 108.54C26.44 108.167 25.6133 107.687 25.04 107.1C24.48 106.513 24.2 105.733 24.2 104.76C24.1867 103.933 24.38 103.227 24.78 102.64C25.1933 102.04 25.7533 101.58 26.46 101.26C27.1667 100.927 27.98 100.76 28.9 100.76C29.8333 100.76 30.6533 100.927 31.36 101.26C32.08 101.593 32.64 102.06 33.04 102.66C33.4533 103.26 33.6733 103.973 33.7 104.8H30.96C30.9467 104.307 30.7533 103.873 30.38 103.5C30.02 103.113 29.5133 102.92 28.86 102.92C28.3 102.907 27.8267 103.047 27.44 103.34C27.0667 103.62 26.88 104.033 26.88 104.58C26.88 105.047 27.0267 105.42 27.32 105.7C27.6133 105.967 28.0133 106.193 28.52 106.38C29.0267 106.567 29.6067 106.767 30.26 106.98C30.9533 107.22 31.5867 107.5 32.16 107.82C32.7333 108.14 33.1933 108.567 33.54 109.1C33.8867 109.62 34.06 110.293 34.06 111.12C34.06 111.853 33.8733 112.533 33.5 113.16C33.1267 113.787 32.5733 114.293 31.84 114.68C31.1067 115.053 30.2067 115.24 29.14 115.24ZM37.2536 119.4L39.5536 114.34H38.9536L35.0936 105.08H37.8736L40.6536 112.06L43.5536 105.08H46.2736L39.9736 119.4H37.2536ZM51.3389 115.24C50.4589 115.24 49.6856 115.1 49.0189 114.82C48.3522 114.527 47.8189 114.127 47.4189 113.62C47.0189 113.113 46.7789 112.527 46.6989 111.86H49.2789C49.3589 112.247 49.5722 112.58 49.9189 112.86C50.2789 113.127 50.7389 113.26 51.2989 113.26C51.8589 113.26 52.2656 113.147 52.5189 112.92C52.7856 112.693 52.9189 112.433 52.9189 112.14C52.9189 111.713 52.7322 111.427 52.3589 111.28C51.9856 111.12 51.4656 110.967 50.7989 110.82C50.3722 110.727 49.9389 110.613 49.4989 110.48C49.0589 110.347 48.6522 110.18 48.2789 109.98C47.9189 109.767 47.6256 109.5 47.3989 109.18C47.1722 108.847 47.0589 108.44 47.0589 107.96C47.0589 107.08 47.4056 106.34 48.0989 105.74C48.8056 105.14 49.7922 104.84 51.0589 104.84C52.2322 104.84 53.1656 105.113 53.8589 105.66C54.5656 106.207 54.9856 106.96 55.1189 107.92H52.6989C52.5522 107.187 51.9989 106.82 51.0389 106.82C50.5589 106.82 50.1856 106.913 49.9189 107.1C49.6656 107.287 49.5389 107.52 49.5389 107.8C49.5389 108.093 49.7322 108.327 50.1189 108.5C50.5056 108.673 51.0189 108.833 51.6589 108.98C52.3522 109.14 52.9856 109.32 53.5589 109.52C54.1456 109.707 54.6122 109.993 54.9589 110.38C55.3056 110.753 55.4789 111.293 55.4789 112C55.4922 112.613 55.3322 113.167 54.9989 113.66C54.6656 114.153 54.1856 114.54 53.5589 114.82C52.9322 115.1 52.1922 115.24 51.3389 115.24ZM61.6342 115C60.5942 115 59.7609 114.747 59.1342 114.24C58.5076 113.733 58.1942 112.833 58.1942 111.54V107.22H56.4942V105.08H58.1942L58.4942 102.42H60.7542V105.08H63.4342V107.22H60.7542V111.56C60.7542 112.04 60.8542 112.373 61.0542 112.56C61.2676 112.733 61.6276 112.82 62.1342 112.82H63.3742V115H61.6342ZM69.9783 115.24C68.9783 115.24 68.0916 115.027 67.3183 114.6C66.5449 114.173 65.9383 113.573 65.4983 112.8C65.0583 112.027 64.8383 111.133 64.8383 110.12C64.8383 109.093 65.0516 108.18 65.4783 107.38C65.9183 106.58 66.5183 105.96 67.2783 105.52C68.0516 105.067 68.9583 104.84 69.9983 104.84C70.9716 104.84 71.8316 105.053 72.5783 105.48C73.3249 105.907 73.9049 106.493 74.3183 107.24C74.7449 107.973 74.9583 108.793 74.9583 109.7C74.9583 109.847 74.9516 110 74.9383 110.16C74.9383 110.32 74.9316 110.487 74.9183 110.66H67.3783C67.4316 111.433 67.6983 112.04 68.1783 112.48C68.6716 112.92 69.2649 113.14 69.9583 113.14C70.4783 113.14 70.9116 113.027 71.2583 112.8C71.6183 112.56 71.8849 112.253 72.0583 111.88H74.6583C74.4716 112.507 74.1583 113.08 73.7183 113.6C73.2916 114.107 72.7583 114.507 72.1183 114.8C71.4916 115.093 70.7783 115.24 69.9783 115.24ZM69.9983 106.92C69.3716 106.92 68.8183 107.1 68.3383 107.46C67.8583 107.807 67.5516 108.34 67.4183 109.06H72.3583C72.3183 108.407 72.0783 107.887 71.6383 107.5C71.1983 107.113 70.6516 106.92 69.9983 106.92ZM76.8914 115V105.08H79.1514L79.3714 106.42C79.6914 105.94 80.1114 105.56 80.6314 105.28C81.1647 104.987 81.7781 104.84 82.4714 104.84C84.0047 104.84 85.0914 105.433 85.7314 106.62C86.0914 106.073 86.5714 105.64 87.1714 105.32C87.7847 105 88.4514 104.84 89.1714 104.84C90.4647 104.84 91.4581 105.227 92.1514 106C92.8447 106.773 93.1914 107.907 93.1914 109.4V115H90.6314V109.64C90.6314 108.787 90.4647 108.133 90.1314 107.68C89.8114 107.227 89.3114 107 88.6314 107C87.9381 107 87.3781 107.253 86.9514 107.76C86.5381 108.267 86.3314 108.973 86.3314 109.88V115H83.7714V109.64C83.7714 108.787 83.6047 108.133 83.2714 107.68C82.9381 107.227 82.4247 107 81.7314 107C81.0514 107 80.4981 107.253 80.0714 107.76C79.6581 108.267 79.4514 108.973 79.4514 109.88V115H76.8914Z",
    fill: "#FFB900"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_10512_2063)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 24,
    y: 133,
    width: 38,
    height: 22,
    rx: 11,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 24,
    y: 133,
    width: 38,
    height: 22,
    rx: 11,
    fill: "url(#paint38_linear_10512_2063)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 24,
    y: 133,
    width: 38,
    height: 22,
    rx: 11,
    fill: "url(#paint39_linear_10512_2063)"
  }))), _path201 || (_path201 = /*#__PURE__*/React.createElement("path", {
    d: "M44.3624 147.851C44.1258 147.613 44.1258 147.228 44.3624 146.989L46.7109 144.612H37.5053C37.1716 144.612 36.8985 144.337 36.8985 144.001C36.8985 143.665 37.1716 143.39 37.5053 143.39H46.7109L44.3564 141.019C44.1197 140.781 44.1197 140.396 44.3564 140.157C44.593 139.919 44.9753 139.919 45.212 140.157L48.6102 143.573C48.8469 143.812 48.8469 144.197 48.6102 144.435L45.2181 147.851C44.9814 148.083 44.593 148.083 44.3624 147.851Z",
    fill: "white"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_10512_2063)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M41.9481 15.8595H44.2965V22.1487H48.4062V24.561H41.9481V15.8595ZM49.7062 15.8595H56.4997V17.9272H52.0126V19.2626H56.0804V21.1579H52.0126V22.5364H56.5417V24.6041H49.7062V15.8595ZM60.9868 15.8164H63.2514L66.8578 24.561H64.3417L63.7126 23.0103H60.4417L59.8546 24.561H57.3804L60.9868 15.8164ZM63.0417 21.1149L62.1191 18.6595L61.1546 21.1149H63.0417ZM67.9901 15.8595H71.261C74.2804 15.8595 76.0417 17.6256 76.0417 20.1672C76.0417 22.6656 74.2804 24.5179 71.2191 24.5179H67.9901V15.8595ZM71.261 22.4072C72.6449 22.4072 73.6094 21.6318 73.6094 20.2103V20.1672C73.6094 18.7887 72.6868 17.9703 71.261 17.9703H70.2965V22.4072H71.261Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.0935 36.28L47.3161 35.5477L45.429 29.6031L49.329 28.3108L48.6161 26.0277L42.4935 28.0523L45.0935 36.28ZM30.5419 21.3323L31.2548 19.0492L37.0419 20.9877L38.929 15L41.1516 15.7323L38.5516 24.0031L30.5419 21.3323ZM44.3806 36.6677L42.4935 38.0892L38.8871 33.0062L30.3323 38.52L24 43L30.4581 33.0062L33.6871 27.6646L28.7387 23.96L30.1226 22.0215L37 27.1477L30.8774 35.9354L39.4323 29.6462L44.3806 36.6677Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_10512_2063",
    x: 16,
    y: 125,
    width: 54,
    height: 38,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_10512_2063"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_10512_2063",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_10512_2063",
    x1: 120.659,
    y1: 155.094,
    x2: 120.659,
    y2: 212.325,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9CBCB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    stopColor: "#D5C7C7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#C9BBBB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BDB0B0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_10512_2063",
    x1: 120.659,
    y1: 204.586,
    x2: 120.659,
    y2: 221.458,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#544140"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#493635"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#463332"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_10512_2063",
    x1: 120.659,
    y1: 156.252,
    x2: 120.659,
    y2: 203.263,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#80D5C9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#71C6C1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#4AA1AD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#49A0AD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_10512_2063",
    x1: 120.659,
    y1: 223.543,
    x2: 120.659,
    y2: 209.825,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#544140"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#493635"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#463332"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_10512_2063",
    x1: 153.673,
    y1: 210.779,
    x2: 153.673,
    y2: 206.928,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CFE852"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#C5DF50"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#ADC74A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A4BF49"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_10512_2063",
    x1: 139.298,
    y1: 159.407,
    x2: 139.298,
    y2: 165.431,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EB5D84"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BF2F56"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_10512_2063",
    x1: 128.134,
    y1: 164.238,
    x2: 128.134,
    y2: 171.993,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CFE852"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#C5DF50"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#ADC74A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A4BF49"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_10512_2063",
    x1: 128.146,
    y1: 171.079,
    x2: 128.146,
    y2: 178.517,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE675"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E57830"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_10512_2063",
    x1: 128.134,
    y1: 178.125,
    x2: 128.134,
    y2: 185.874,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#80D5C9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#56ACB3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#49A0AD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_10512_2063",
    x1: 128.134,
    y1: 185.066,
    x2: 128.134,
    y2: 192.816,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#808ED5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#566AB3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4953AD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_10512_2063",
    x1: 104.441,
    y1: 159.618,
    x2: 104.441,
    y2: 165.642,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EB5D84"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BF2F56"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_10512_2063",
    x1: 93.2766,
    y1: 164.238,
    x2: 93.2766,
    y2: 171.993,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CFE852"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#C5DF50"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#ADC74A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A4BF49"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_10512_2063",
    x1: 93.2895,
    y1: 171.079,
    x2: 93.2895,
    y2: 178.517,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE675"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E57830"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_10512_2063",
    x1: 93.2766,
    y1: 178.125,
    x2: 93.2766,
    y2: 185.874,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#80D5C9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#56ACB3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#49A0AD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_10512_2063",
    x1: 136.21,
    y1: 214.611,
    x2: 136.247,
    y2: 227.092,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#80D5C9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#71C6C1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#4AA1AD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#49A0AD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_10512_2063",
    x1: 131.005,
    y1: 214.581,
    x2: 131.042,
    y2: 227.063,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#80D5C9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#71C6C1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#4AA1AD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#49A0AD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_10512_2063",
    x1: 131.696,
    y1: 199.808,
    x2: 131.696,
    y2: 218.976,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E8D9D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    stopColor: "#E4D5D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#D8C9C9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CCBEBE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_10512_2063",
    x1: 176.895,
    y1: 179.3,
    x2: 176.895,
    y2: 188.999,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9CBCB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    stopColor: "#D5C7C7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#C9BBBB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BDB0B0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_10512_2063",
    x1: 175.819,
    y1: 178.143,
    x2: 175.819,
    y2: 190.068,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#544140"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#493635"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#463332"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_10512_2063",
    x1: 156.579,
    y1: 191.172,
    x2: 156.579,
    y2: 218.458,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#987FC9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#60578F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_10512_2063",
    x1: 147.475,
    y1: 206.673,
    x2: 141.92,
    y2: 198.778,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB182"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#FDAC7E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#F99E72"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#F3875F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EC6B47"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_10512_2063",
    x1: 130.692,
    y1: 197.24,
    x2: 130.567,
    y2: 239.661,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EB5D84"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BF2F56"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear_10512_2063",
    x1: 180.04,
    y1: 197.213,
    x2: 180.04,
    y2: 239.03,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EB5D84"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BF2F56"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear_10512_2063",
    x1: 160.534,
    y1: 168.929,
    x2: 160.534,
    y2: 205.243,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9E5141"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#864235"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#5A271F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#491D17"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint24_linear_10512_2063",
    x1: 167.465,
    y1: 199.529,
    x2: 167.465,
    y2: 192.516,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB182"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#FDAC7E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#FA9E72"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#F4885F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EC6B47"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint25_linear_10512_2063",
    x1: 169.643,
    y1: 168.93,
    x2: 169.643,
    y2: 205.243,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9E5141"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#864235"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#5A271F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#491D17"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint26_linear_10512_2063",
    x1: 167.519,
    y1: 197.215,
    x2: 167.519,
    y2: 239.032,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EB5D84"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BF2F56"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint27_linear_10512_2063",
    x1: 167.901,
    y1: 200.12,
    x2: 167.901,
    y2: 189.988,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB182"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#FDAC7E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#FA9E72"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#F4885F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EC6B47"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint28_linear_10512_2063",
    x1: 152.562,
    y1: 197.214,
    x2: 152.562,
    y2: 239.031,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EB5D84"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BF2F56"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint29_linear_10512_2063",
    x1: 168.301,
    y1: 168.93,
    x2: 168.301,
    y2: 205.244,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9E5141"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#864235"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#5A271F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#491D17"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint30_linear_10512_2063",
    x1: 167.91,
    y1: 169.646,
    x2: 167.91,
    y2: 180.652,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#544140"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#493635"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#463332"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint31_linear_10512_2063",
    x1: 158.143,
    y1: 178.115,
    x2: 158.143,
    y2: 190.04,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#544140"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#493635"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#463332"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint32_linear_10512_2063",
    x1: 157.041,
    y1: 179.3,
    x2: 157.041,
    y2: 188.999,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9CBCB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    stopColor: "#D5C7C7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#C9BBBB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BDB0B0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint33_linear_10512_2063",
    x1: 179.543,
    y1: 239.509,
    x2: 179.543,
    y2: 194.698,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#463332"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#503D3C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#544140"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint34_linear_10512_2063",
    x1: 181.56,
    y1: 239.509,
    x2: 181.56,
    y2: 194.698,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#322424"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#3C2D2D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#403131"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint35_linear_10512_2063",
    x1: 89.4125,
    y1: 217.85,
    x2: 89.4125,
    y2: 226.445,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#987FC9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#60578F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint36_linear_10512_2063",
    x1: 87.8486,
    y1: 208.909,
    x2: 87.8486,
    y2: 214.774,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EB5D84"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BF2F56"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint37_linear_10512_2063",
    x1: 89.3948,
    y1: 214.606,
    x2: 89.3948,
    y2: 218.113,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE675"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E57830"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint38_linear_10512_2063",
    x1: 62,
    y1: 155,
    x2: 22.0901,
    y2: 150.692,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ED5E1E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9A5A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint39_linear_10512_2063",
    x1: 43,
    y1: 101.604,
    x2: 43,
    y2: 155,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEDA44"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF5F00"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_10512_2063"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 185,
    height: 226,
    rx: 24,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_10512_2063"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 52,
    height: 28,
    fill: "white",
    transform: "translate(24 15)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTasShort);
export default __webpack_public_path__ + "static/media/TAS_Short.041c76b8351cd29f52f955adaf4ccb03.svg";
export { ForwardRef as ReactComponent };